export default __webpack_public_path__ + "static/media/BrainBreak cards76.9630c198.png";